const {
	fillWithDomElements,
	fillWithDomElementsAll,
	mediaQueryMin,
	freezeScroll,
	awaitControllersReady,
	unfreezeScroll,
	getNumber,
	trackGtm,
	trackGtm4,
} = require('util/functions');
const {
	default: { breakMedium, mediumDelay },
} = require('util/sass-variables');
const asyncImport = require('util/asyncImport').default;
const { stuttering, default: onWidthResize } = require('util/onWidthResize');

const duration = getNumber(mediumDelay) * 1000;
const { MAIN_EASING } = require('util/consts');

const CLASS_LIST_BTN = 'filters--list-view';
const CLASS_GRID_BTN = 'filters--grid-view';
const CLASS_TABLE_CONTAINER = 'filters--table';
const CLASS_GRID_CONTAINER = 'filters--grid';
const CLASS_FILTER_TITLE = 'filters--title';
const CLASS_FILTER_BTN = 'filters--filters-mobile-btn';
const CLASS_FILTER_COUNT = 'filters--filters-mobile-count';
const CLASS_MOBILE_CONTAINER = 'filters--filters-mobile';
const CLASS_MOBILE_FILTER = 'filters--filters-mobile-scroll';
const CLASS_MOBILE_CLOSE = 'filters--filters-mobile-close';
const CLASS_MOBILE_APPLY = 'filters--filters-apply';
const CLASS_NAV = 'pages-nav';
const CLASS_LIST = 'filters--list';
const CLASS_LIST_ITEM = 'filters--list-item';
const CLASS_TABLE_BODY = 'filters--table-body';
const CLASS_CLEAR_BTN = 'filters--clear-button';
const CLASS_FOUND_LABEL = 'filters--results-found';
const CLASS_NEWEST = 'filters--newest';
const CLASS_OLDEST = 'filters--oldest';
const CLASS_DOWNLOAD = 'filters--download';
const CLASS_DESCRITPION_SORT_BTN = 'filters--column-sort';
const CLASS_DOWN_ARROW = 'filters--down-arrow';
const CLASS_UP_ARROW = 'filters--up-arrow';
const CLASS_IMAGE_SAMPLE = 'filters--image-sample';

const CLASS_LOADING_OVERLAY = 'loading-overlay';
const CLASS_ACTIVE = 'active';
const CLASS_DESC = 'desc';
const CLASS_ARTICLE_LIST = 'filters--list-articles';
const CLASS_ARTICLE_ITEM = 'filters--article-image';
const CLASS_ARTICLE_LINK = 'filters--article-link';
const CLASS_FILTER_DOWNLOAD = '.filters--download';

const renderTableView = require('./table-view/template.hbs');
const renderArticleView = require('./article-view/template.hbs');
const renderDocument = require('../../components/document-download-partial/template.hbs');

const selectors = {
	listBtn: CLASS_LIST_BTN,
	gridBtn: CLASS_GRID_BTN,
	listContainer: CLASS_TABLE_CONTAINER,
	gridContainer: CLASS_GRID_CONTAINER,
	filterTitle: CLASS_FILTER_TITLE,
	loadingOverlay: CLASS_LOADING_OVERLAY,
	filterBtn: CLASS_FILTER_BTN,
	filterCount: CLASS_FILTER_COUNT,
	filterMobileContainer: CLASS_MOBILE_CONTAINER,
	filterMobileScroll: CLASS_MOBILE_FILTER,
	closeBtn: CLASS_MOBILE_CLOSE,
	applyBtn: CLASS_MOBILE_APPLY,
	navElement: CLASS_NAV,
	tableBody: CLASS_TABLE_BODY,
	clearBtn: CLASS_CLEAR_BTN,
	foundCount: CLASS_FOUND_LABEL,
	newestSort: CLASS_NEWEST,
	oldestSort: CLASS_OLDEST,
	descritpionBtn: CLASS_DESCRITPION_SORT_BTN,
	imageSample: CLASS_IMAGE_SAMPLE,
};
const selectorsAll = {
	upArrow: CLASS_UP_ARROW,
	downArrow: CLASS_DOWN_ARROW,
	filtersItems: CLASS_LIST_ITEM,
	filterLists: CLASS_LIST,
	downloads: CLASS_DOWNLOAD,
	articleItems: CLASS_ARTICLE_ITEM,
	articleLinks: CLASS_ARTICLE_LINK,
};
module.exports = {
	async init() {
		fillWithDomElements(this, selectors);
		fillWithDomElementsAll(this, selectorsAll);
		await asyncImport(this, ['anime', 'debounce']);
		await awaitControllersReady([this.navElement]);
		this.isArticleTemplate = !!this.root.dataset.articleTemplate;
		this.backPictureSample = this.imageSample?.querySelector('.back-picture');
		this.imageSample?.remove();
		this.navController = this.navElement.__controller;
		this.apiUrl = this.root.dataset.api;
		this.rowsToShow = this.root.dataset.rowsToShow;
		this.allCheckeboxes = [];
		this.filtersItems.forEach(element => {
			let checkbox = element.querySelector('input[type=checkbox]');
			this.allCheckeboxes.push(checkbox.value);
		});
		this.checkedCheckboxes = [];
		this.applyedCheckboxes = [];
		this.activePage = 0;
		this.activeSort = this.root.dataset.order.toLowerCase();
		this.initEvents();
		this.initPagination();
		onWidthResize(this.onResize.bind(this), stuttering.DEBOUNCE, 250);
		const widgetName = this.root.getAttribute('data-parent');
		this.articleItems.forEach(articleItem => {
			articleItem?.addEventListener('click', () => {
				trackGtm4({
					event: 'GA4_event_c_cta',
					widget_name: widgetName,
					widget_title: this.filterTitle.innerHTML,
					link_text: 'No text: Picture link',
					link_url: articleItem.href,
					button_type: '',
				});
			});
		});
		this.articleLinks.forEach(articleLink => {
			articleLink?.addEventListener('click', () => {
				trackGtm4({
					event: 'GA4_event_c_cta',
					widget_name: widgetName,
					widget_title: this.filterTitle.innerHTML,
					link_text: articleLink.innerHTML,
					link_url: articleLink.href,
					button_type: '',
				});
			});
		});
	},
	initEvents() {
		const widgetName = this.root.getAttribute('data-parent');
		if (this.root.dataset.showSort === 'true') {
			this.toggleSortClass();
			this.newestSort.addEventListener('click', this.sort.bind(this));
			this.oldestSort.addEventListener('click', this.sort.bind(this));
		}
		this.addScrollToList();
		this.listBtn?.addEventListener('click', this.toggleView.bind(this, false));
		this.gridBtn?.addEventListener('click', this.toggleView.bind(this, true));
		this.clearBtn?.addEventListener('click', this.clearFilters.bind(this));
		this.descritpionBtn?.addEventListener('click', this.sort.bind(this));
		this.upArrow?.forEach(element => {
			element.addEventListener('click', () => {
				this.scrollList.bind(this, true, element);
				trackGtm4({
					event: 'GA4_event_c_content_navigation_click',
					widget_name: widgetName,
					widget_title: this.filterTitle.innerHTML,
					widget_type: 'search',
					link_text: element.getAttribute('aria-label')
						? element.getAttribute('aria-label')
						: 'No text: upArrow',
					link_url: element.href ? element.href : 'No url',
					interaction_type: 'up',
				});
			});
		});
		this.downArrow?.forEach(element => {
			element.addEventListener('click', () => {
				this.scrollList.bind(this, false, element);
				trackGtm4({
					event: 'GA4_event_c_content_navigation_click',
					widget_name: widgetName,
					widget_title: this.filterTitle.innerHTML,
					widget_type: 'search',
					link_text: element.getAttribute('aria-label')
						? element.getAttribute('aria-label')
						: 'No text: upArrow',
					link_url: element.href ? element.href : 'No url',
					interaction_type: 'down',
				});
			});
		});
		this.downloads?.forEach(element => {
			element.addEventListener('click', this.downloadClick.bind(this, element));
		});
		this.filterBtn?.addEventListener(
			'click',
			this.toggleFilters.bind(this, true),
		);
		this.closeBtn?.addEventListener(
			'click',
			this.closeMobileFilter.bind(this, false),
		);
		this.applyBtn?.addEventListener('click', this.applyClick.bind(this, false));
		this.filtersItems?.forEach(element => {
			element.addEventListener('change', this.onCheck.bind(this, element));
			element.addEventListener('keyup', e => {
				if (e.keyCode === 13) {
					if (element.querySelector('input').checked === true) {
						element.querySelector('input').checked = false;
					} else {
						element.querySelector('input').checked = true;
					}
					this.onCheck(element);
				}
			});
		});
	},
	closeMobileFilter() {
		this.toggleFilters(false);
		this.unCheck();
	},
	unCheck() {
		this.filtersItems.forEach(element => {
			let checkedCheckbox = element.querySelector(
				'input[type=checkbox]:checked',
			);
			let checkbox = element.querySelector('input[type=checkbox]');
			if (
				checkedCheckbox &&
				!this.applyedCheckboxes.includes(checkedCheckbox.value)
			) {
				checkedCheckbox.checked = false;
			}
			if (this.applyedCheckboxes.includes(checkbox.value))
				checkbox.checked = true;
		});
	},
	onResize() {
		if (!mediaQueryMin(breakMedium)) {
			this.filterMobileContainer.style.height = '0';
		} else {
			this.checkedCheckboxes = [];
			this.filtersItems.forEach(element => {
				let checkbox = element.querySelector('input[type=checkbox]');
				if (checkbox && !this.applyedCheckboxes.includes(checkbox.value)) {
					checkbox.checked = false;
				}
			});
			this.filterMobileContainer.style.height = '100%';
		}
		this.addScrollToList();
		this.toggleFilters(false);
	},
	downloadClick(element) {
		const title = `${element.dataset.title} / ${element.href}`;
		this.gtmTracking('outgoing tracking', 'download', title);
	},
	applyClick() {
		this.activePage = 0;
		this.toggleFilters(false);
		this.updateResults();
	},
	onCheck(listItem) {
		if (!mediaQueryMin(breakMedium)) {
			this.checkedCheckboxes = [];
			this.filtersItems.forEach(element => {
				let checkbox = element.querySelector('input[type=checkbox]:checked');
				if (checkbox) {
					this.checkedCheckboxes.push(checkbox.value);
				}
			});
		} else {
			this.activePage = 0;
			this.updateResults();
		}
		const action = listItem.dataset.categoryName;
		const label = listItem.querySelector('label').innerHTML;
		const widgetName = this.root.getAttribute('data-parent');
		this.gtmTracking('filters', action, label);
		trackGtm4({
			event: 'GA4_event_c_cta',
			widget_name: widgetName,
			widget_title: this.filterTitle.innerHTML,
			link_text: label,
			link_url: 'No url: Checkbox label',
			button_type: '',
		});
	},
	gtmTracking(category, action, label) {
		trackGtm({
			eventCategory: category,
			eventAction: action,
			eventLabel: label,
		});
	},
	gtm4Tracking(event, location, name) {
		trackGtm4({
			event: event,
			search_location: location,
			widget_name: name,
		});
	},
	initPagination() {
		this.pageCount = Number(this.root.dataset.pagesCount);
		this.setPagination(0, this.pageCount);
	},
	setPagination(current, total) {
		this.navController.setDynamicPagination(
			current,
			total - 1,
			this.changePage.bind(this),
		);
	},
	changePage(number) {
		this.activePage = number;
		this.navController.setActivePage(number);
		const widgetName = this.root.getAttribute('data-parent');
		this.updateResults();
		// eslint-disable-next-line no-restricted-globals
		const action = event.srcElement.getAttribute('aria-label')
			? // eslint-disable-next-line no-restricted-globals
			  event.srcElement.getAttribute('aria-label')
			: number + 1;
		this.gtmTracking('content-navigation', action, 'filters widget');
		trackGtm4({
			event: 'GA4_event_c_content_navigation_click',
			widget_name: widgetName,
			widget_title: this.filterTitle.innerHTML,
			widget_type: 'search',
			link_text: action ? (!isNaN(action) ? action : action) : 'no text',
			link_url: 'No url',
			interaction_type: !isNaN(action)
				? `page ${action}`
				: action.toLowerCase(),
		});
	},
	async updateResults() {
		this.loadingOverlay.classList.add(CLASS_ACTIVE);
		this.gridContainer.classList.add('hidden');
		const { content, pagesCount, totalCount } = await this.fetch();
		this.pageCount = pagesCount;
		if (!this.isArticleTemplate) {
			this.tableBody.innerHTML = content
				.map(data =>
					renderTableView({
						...data,
					}),
				)
				.join('');
			setTimeout(() => {
				this.gridContainer.innerHTML = content
					.map(data =>
						renderDocument({
							...data,
							backPicture: this.getBackPicture(data),
							downloadLabel: this.root.dataset.downloadLabel,
							list: true,
						}),
					)
					.join('');
				this.root
					.querySelectorAll('.document-download-partial--download-list')
					.forEach(element => {
						element.addEventListener(
							'click',
							this.downloadClick.bind(this, element),
						);
					});
			}, 200);

			this.root.querySelectorAll(CLASS_FILTER_DOWNLOAD).forEach(element => {
				element.addEventListener(
					'click',
					this.downloadClick.bind(this, element),
				);
			});
		} else {
			setTimeout(() => {
				this.gridContainer.innerHTML = content
					.map(data =>
						renderArticleView({
							...data,
							backPicture: this.getBackPicture(data),
							category: this.root.dataset.category,
							ctaLabel: this.root.dataset.ctaLabel,
							logo: {
								url: this.root.dataset.logoUrl,
								alt: this.root.dataset.logoAlt,
							},
						}),
					)
					.join('');
			}, 200);
		}
		if (this.root.dataset.showNumberOfDocuments) {
			this.foundCount.innerHTML = totalCount
				? totalCount > 1
					? `${totalCount} ${this.root.dataset.foundCountLabelPlural}`
					: `${totalCount} ${this.root.dataset.foundCountLabel}`
				: this.root.dataset.noResultsLabel;
		}
		this.toggleClearBtn();
		this.setPagination(this.activePage, pagesCount);
		setTimeout(() => {
			this.loadingOverlay.classList.remove(CLASS_ACTIVE);
			this.gridContainer.classList.remove('hidden');
		}, 400);
	},
	getBackPicture(data) {
		const { image, hasGradient } = data;
		if (image) {
			this.backPictureSample.classList.toggle('has-gradient', !!hasGradient);
			this.renderBackPicture = this.getRenderBackPictureFn();
			const { url, alt } = image;
			return this.renderBackPicture(url, alt);
		} else return ' ';
	},

	getRenderBackPictureFn() {
		const content = this.backPictureSample.outerHTML;
		const {
			alt,
			dataset: { src },
		} = this.backPictureSample.querySelector('img');
		const trimSrc = src.trim();
		return (newSrc, newAlt) =>
			content
				.replaceAll(`alt="${alt}"`, `alt="${newAlt}"`)
				.replaceAll(trimSrc, newSrc);
	},
	clearFilters() {
		this.filtersItems.forEach(element => {
			let checkbox = element.querySelector('input[type=checkbox]:checked');
			if (checkbox) {
				checkbox.checked = false;
			}
		});
		this.checkedCheckboxes = [];
		this.updateResults();
		this.gtmTracking('filters', 'click', 'clear all');
		this.gtm4Tracking(
			'GA4_event_c_search_filter_clear_all',
			'page',
			'V3-Filter',
		);
	},
	toggleClearBtn() {
		if (this.checkedCheckboxes.length > 0) {
			this.filterCount.innerHTML = `(${this.checkedCheckboxes.length})`;
			this.clearBtn.classList.add(CLASS_ACTIVE);
		} else {
			this.filterCount.innerHTML = '';
			this.clearBtn.classList.remove(CLASS_ACTIVE);
		}
	},
	async fetch() {
		const url = await this.getUrl();
		const response = await fetch(url).catch(error => console.error(error));
		if (!response.ok) throw new Error('filter api response error');
		return await response.json();
	},
	getUrl() {
		this.checkedCheckboxes = [];
		this.applyedCheckboxes = [];
		this.filtersItems.forEach(element => {
			let checkbox = element.querySelector('input[type=checkbox]:checked');
			if (checkbox) {
				this.checkedCheckboxes.push(checkbox.value);
				this.applyedCheckboxes.push(checkbox.value);
			}
		});
		const filters =
			this.checkedCheckboxes.length > 0
				? this.checkedCheckboxes.join(',')
				: this.allCheckeboxes.join(',');
		let url = `${this.apiUrl}?page=${this.activePage}&order=${this.activeSort}&rowsToShow=${this.rowsToShow}&filters=${filters}`;
		return url;
	},
	toggleFilters(open) {
		if (open) {
			freezeScroll();
		} else {
			unfreezeScroll();
		}
		this.anime({
			targets: this.filterMobileContainer,
			height: open ? '100%' : 0,
			easing: MAIN_EASING,
			duration,
		});
	},
	scrollList(scrollUp, element) {
		element.parentNode.querySelector('.filters--list').scrollBy({
			left: 0,
			top: scrollUp ? -30 : 30,
			behavior: 'smooth',
		});
	},
	toggleView(gridView) {
		if (!this.isArticleTemplate) {
			this.listContainer.classList.toggle(
				CLASS_ACTIVE,
				gridView ? false : true,
			);
			this.gridContainer.classList.toggle(CLASS_ACTIVE, gridView);
		} else {
			this.gridContainer.classList.toggle(CLASS_ARTICLE_LIST, !gridView);
		}
		this.loadingOverlay.classList.add(CLASS_ACTIVE);
		this.listBtn.classList.toggle(CLASS_ACTIVE, gridView ? false : true);
		this.gridBtn.classList.toggle(CLASS_ACTIVE, gridView);
		this.loadingOverlay.classList.remove(CLASS_ACTIVE);
		const view = gridView ? 'tile view' : 'list view';
		const widgetName = this.root.getAttribute('data-parent');
		this.gtmTracking('content-display', view, 'filters widget');
		trackGtm4({
			event: 'GA4_event_c_cta',
			widget_name: widgetName,
			widget_title: this.filterTitle.innerHTML,
			link_text: gridView ? 'Grid view' : 'List view',
			link_url: 'No url: Button change view',
			button_type: '',
		});
		trackGtm4({
			event: 'GA4_event_c_content_display',
			widget_name: widgetName,
			widget_title: this.filterTitle.innerHTML,
			content_display_view_type: view,
		});
	},
	addScrollToList() {
		this.filterLists.forEach(element => {
			if (!!element.dataset.scroll) {
				const items = element.querySelectorAll('.filters--list-item');
				let height = 0;
				items.forEach((item, index) => {
					if (index <= 4) height += item.offsetHeight;
				});
				element.style.height = mediaQueryMin(breakMedium)
					? `${height}px`
					: '100%';
			}
		});
	},
	toggleSortClass() {
		if (this.activeSort === 'newest') {
			this.newestSort.classList.add(CLASS_ACTIVE);
			this.newestSort.disabled = true;
			this.oldestSort.classList.remove(CLASS_ACTIVE);
			this.oldestSort.disabled = false;
		} else if (this.activeSort === 'oldest') {
			this.oldestSort.classList.add(CLASS_ACTIVE);
			this.oldestSort.disabled = true;
			this.newestSort.classList.remove(CLASS_ACTIVE);
			this.newestSort.disabled = false;
		} else {
			this.newestSort.classList.remove(CLASS_ACTIVE);
			this.newestSort.disabled = false;
			this.oldestSort.classList.remove(CLASS_ACTIVE);
			this.oldestSort.disabled = false;
		}
	},
	sort({ target }) {
		if (target.getAttribute('name')) {
			this.activeSort = target.getAttribute('name').toLowerCase();
		} else if (target.classList.contains(CLASS_DESC)) {
			target.classList.remove(CLASS_DESC);
			this.activeSort = 'asc';
		} else {
			target.classList.add(CLASS_DESC);
			this.activeSort = 'desc';
		}

		// Tracking sort
		if (target.getAttribute('name') === 'oldest') {
			this.trackingSortGa4('oldest');
		} else {
			this.trackingSortGa4('newest');
		}
		this.toggleSortClass();
		this.updateResults();
	},
	trackingSortGa4(sortingType) {
		const widgetName = this.root.getAttribute('data-parent');
		trackGtm4({
			event: 'GA4_event_c_content_sorting',
			widget_name: widgetName,
			widget_title: this.filterTitle.innerHTML,
			content_sorting_type: sortingType,
		});
	},
};
